export enum EntityTypeDTO {
  USER = 'USER',
  PROJECT = 'PROJECT',
  CLIENT = 'CLIENT',
  INVOICE = 'INVOICE',
  ASSIGNMENT = 'ASSIGNMENT',
  WORKLOG = 'WORKLOG',
  ISSUE = 'ISSUE',
}

/**
 * Type alias for response - makes intent clear
 */
export type EntityTypeResponse = EntityTypeDTO;

/**
 * Type alias for request - makes intent clear
 */
export type EntityTypeRequest = EntityTypeDTO;
